import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-evaluation",
  "use": "icon-evaluation-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-evaluation\">\r\n  <path d=\"M511.564 27.006 465.06 112.728l-118.876 219.136L104.712 379.016l-92.922 18.146 64.156 69.624 168.538 182.904-30.616 248.844-11.776 95.714 87.048-41.502 222.42-106.042 222.42 106.042 87.048 41.502-11.776-95.714L778.64 649.692l168.54-182.906 64.154-69.622-92.92-18.146-241.48-47.152L558.064 112.73 511.564 27.006 511.564 27.006z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol